import Multiselect from 'multiselect-react-dropdown';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TidalButton } from '../common/button';
import TidalDropdown from '../common/dropdown/TidalDropdown';
import TidalChipInput from '../common/input/TidalChipInput';
import { Box } from '../Flex';

interface IShopFilterModal {
  // categories: any[];
  minPrice: number;
  maxPrice: number;
  tags: any[];
  tagsData: [];
  onClose: () => void;
  applyFilters: (
    categoryId: string,
    tags: any[],
    minPrice: number,
    maxPrice: number,
  ) => void;
}

const ShopFilterModalWrapper = styled.div`
  padding: 8px 16px;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 8px;
  width: 512px;
  max-width: 100%;
  & > h1 {
    font-weight: bold;
    font-size: 32px;
    margin-bottom: 12px;
  }
`;

const ShopFilterCategorySection = styled.div`
  & > .title {
    font-weight: 500;
    font-size: 22px;
  }
`;

const ShopFilterPriceSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 8fr;
  align-items: center;
  grid-gap: 0 16px;
  height: 42px;
  padding: 0 8px;
  padding-right: 0;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  & > .label {
    font-size: 15px;
    font-weight: 400;
  }
  & > input {
    height: 100%;
    padding: 0 8px;
    background-color: ${(props) => props.theme.colors.secondary};
  }
`;

const ShopFilterFooter = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  padding-top: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0 8px;
  div {
    width: 100%;
  }
`;

const MultiSelectWrapper = styled.div`
  .optionListContainer {
    border-radius: 8px;
    margin-top: 4px;
    ul {
      border-radius: 8px;
    }
  }
  & > div > div > div:nth-child(1) {
    border: 1px solid #e5e8f0;
    border-radius: 10px;
    background-color: #f2f4f9;
    height: 42px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    gap: 0 8px;
    span {
      display: grid;
      margin: 0;
      grid-template-columns: 1fr 20px;
    }

    input {
      width: 100%;
      padding: 0 10px;
      height: 100%;
      box-shadow: none;
      font-size: 14px;
      color: black;
      &::placeholder {
        color: black;
      }
      &:focus {
        border: none;
        outline: none;
        border-color: transparent;
      }
      margin: 0;
    }
  }
`;

const ShopFilterModal = ({
  // categories,
  applyFilters,
  onClose,
  minPrice,
  maxPrice,
  tags,
  tagsData,
}: IShopFilterModal) => {
  const [selectedCategoryID, setSelectedCategoryID] = useState('');
  const [minPriceState, setMinPrice] = useState(minPrice);
  const [maxPriceState, setMaxPrice] = useState(maxPrice);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    setMinPrice(minPrice);
    setMaxPrice(maxPrice);
    setSelectedTags(tags);
    // setTags();
  }, [tags, minPrice, maxPrice]);

  const handleApplyFilters = () => {
    applyFilters(
      selectedCategoryID,
      selectedTags,
      minPriceState,
      maxPriceState,
    );
  };

  return (
    <ShopFilterModalWrapper>
      <h1>Filters</h1>
      <ShopFilterCategorySection>
        <h1 className="title" data-tour="step-3">
          Pricing
        </h1>
        <ShopFilterPriceSection>
          <p className="label">Min price</p>
          <input
            type="number"
            value={minPriceState}
            onChange={(e: any) => setMinPrice(e.target.value)}
          />
        </ShopFilterPriceSection>
        <Box height={8} />
        <ShopFilterPriceSection>
          <p className="label">Max price</p>
          <input
            type="number"
            value={maxPriceState}
            onChange={(e: any) => setMaxPrice(e.target.value)}
          />
        </ShopFilterPriceSection>
      </ShopFilterCategorySection>
      <Box height={16} />

      {/* {categories && (
        <ShopFilterCategorySection>
          <h1 className="title">Category</h1>
          <TidalDropdown
            defaultValue="Select Category"
            items={categories?.map((c: any) => c.name)}
            onSelect={(e) => {
              setSelectedCategoryID(
                categories?.find((c: any) => c.name == e).id,
              );
            }}
            label=""
          />
        </ShopFilterCategorySection>
      )} */}
      <Box height={16} />
      <ShopFilterCategorySection>
        <h1 className="title" data-tour="step-4">
          Tags
        </h1>
        {/* <TidalChipInput
          initialTags={tagsState}
          onTagsChanged={(tags: any) => setTags(tags)}
        /> */}
      </ShopFilterCategorySection>
      <Box height={12} />

      <MultiSelectWrapper>
        <Multiselect
          options={tagsData.map((item, index) => ({
            label: item,
          }))}
          selectedValues={selectedTags}
          onSelect={(selectedList, selectedItem) =>
            setSelectedTags(selectedList)
          }
          onRemove={(selectedList, selectedItem) => {
            setSelectedTags(selectedList);
          }}
          displayValue="label"
        />
      </MultiSelectWrapper>
      <Box height={32} />
      <ShopFilterFooter>
        <TidalButton
          text="Close"
          type="default"
          tint={true}
          onClick={onClose}
        />
        <div data-tour="step-5">
          <TidalButton
            text="Apply filters"
            type="primary"
            tint={false}
            onClick={handleApplyFilters}
          />
        </div>
      </ShopFilterFooter>
      <Box height={16} />
    </ShopFilterModalWrapper>
  );
};

export default ShopFilterModal;
